
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-center",
      function () {
        return require("private-next-pages/course-center/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course-center"])
      });
    }
  